import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 }, // md=900
  },
  typography: {
    fontFamily: '"Montserrat", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
    button: {
      textTransform: "uppercase",
      letterSpacing: "0.08em",
      fontWeight: 600,
    },
  },
});
